<template>
  <div class="ltr">
    <div class="columns">
      <div class="column">
        <BaseInput class="input" v-model="min" label="Min Experience" placeholder="Min ..." />
      </div>
      <div class="column">
        <BaseInput class="input" v-model="max" label="Max Experience (optional)" placeholder="Max ..." />
      </div>
    </div>
    <div class="modal_footer">
      <a @click="submit()" class="button is-info">Submit Filters</a>
      <div class="horizontal_space"></div>
      <a @click="clearFilter()" class="filter button is-danger">Clear Filters</a>
      <div class="horizontal_space"></div>
      <a @click="newCertified()" class="filter button is-warning">מוסמכים חדשים</a>
    </div>
  </div>
</template>
<script>
import BaseInput from '@/components/shared/atoms/BaseInput'

export default {
  name: 'FilterMinMaxExperienceInputRange',
  components: {
    BaseInput
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      min: '',
      max: ''
    }
  },
  created () {
    const data = this.$route.query[this.payload.designator].split(this.payload.splitter)
    this.min = data[0]
    this.max = data[1]
  },
  methods: {
    submit () {
      if (!this.max) {
        this.max = this.min
      }
      let query = { ...this.$route.query }
      query[this.payload.designator] = this.min ? `${this.min}|${this.max}` : undefined
      this.$router.push({ path: this.$route.path, query: query })
    },
    clearFilter () {
      this.min = undefined
      this.max = undefined
    },
    newCertified () {
      this.min = '0'
      this.max = '0.5'
      this.submit()
    }
  }
}
</script>
